import { useForm } from 'components/form/Form';
import { useValue } from 'components/form/hook/useValue';
import { classNames } from 'libs/react';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { TextAreaInput } from 'components/form/private/inputs/TextAreaInput';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import './FormTextArea.scss';
/**
 * @component FormTextArea
 * @since 1.0.0
 */
export function FormTextArea(props) {
    let { name, size, style, infos, label, error, disabled, required, optional, placeholder, tooltip, autoselect, autocorrect, autocomplete, autocapitalize, prefix, suffix, rows } = Object.assign({ style: 'normal' }, props);
    const form = useForm();
    const [ident] = useIdent('form-text-area');
    const [value, setValue] = useValue(name, props.value, props.defaultValue || '');
    const [focused, setFocused] = useState(false);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value) {
        setValue(value);
    }
    useIf(focused, props.onFocus, props.onBlur);
    useWatch(() => {
        if (props.onChange) {
            props.onChange(value);
        }
    }, [value]);
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-text-area', 'form-text-area--' + style, { 'form-text-area--is-required': required }, { 'form-text-area--is-optional': optional }, { 'form-text-area--is-disabled': disabled }, { 'form-text-area--is-focused': focused }, { 'form-text-area--has-label': label }, { 'form-text-area--has-value': value }, { 'form-text-area--has-error': error }, props.className);
    return (React.createElement(Fragment, null,
        React.createElement("div", { className: className },
            React.createElement("div", { className: "form-text-area-field" },
                React.createElement("div", { className: "form-text-area-field-head" },
                    label && (React.createElement(FormFieldLabel, { className: "form-text-area-label", size: size, style: style, label: label, ident: ident, tooltip: tooltip, required: required, optional: optional, disabled: disabled })),
                    infos && (React.createElement(FormFieldInfos, { className: "form-text-area-infos", size: size, style: style, infos: infos }))),
                React.createElement("div", { className: "form-text-area-field-body" },
                    prefix && React.createElement("div", { className: "form-text-area-prefix" }, prefix),
                    React.createElement(TextAreaInput, { name: name, ident: ident, value: value, required: required, disabled: disabled, placeholder: placeholder, autoselect: autoselect, autocorrect: autocorrect, autocomplete: autocomplete, autocapitalize: autocapitalize, rows: rows, onBlur: onBlur, onFocus: onFocus, onChange: onChange }),
                    suffix && React.createElement("div", { className: "form-text-area-suffix" }, suffix)))),
        React.createElement(FormFieldError, { error: error })));
}
